module.exports = __webpack_public_path__ + "static/media/receipt_printer_icon.acebf645.svg";